"use client";

import { useEffect } from "react";
import { ErrorDisplay } from "../../components/error-boundary/dds-error-display";
import { reportAppRouterBoundaryError } from "../../components/error-boundary/report-app-router-error";

interface SlugErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// Per-segment boundary for app/v2/[...slug]. A render failure inside the
// generic slug page lands here and the global layout (header/footer/theme)
// continues to render around it — instead of bubbling to app/error.tsx and
// blanking the chrome.
//
// Caveat: this does NOT catch errors thrown by the same segment's layout.tsx
// (data fetch, header build, provider setup). Those bubble to app/error.tsx
// and lose chrome. See Next.js docs:
// https://nextjs.org/docs/app/building-your-application/routing/error-handling
export default function SlugError({ error }: SlugErrorProps) {
  useEffect(() => {
    reportAppRouterBoundaryError("AppRouter:SlugError", error);
  }, [error]);

  return (
    <ErrorDisplay
      hideCloseButton
      component="AppRouter:Slug"
      error={error}
    />
  );
}
